import DashboardForDepartmentActionTypes from './dashboardfordepartment.types';

interface AttendancePayload {
	currentmonth: string;
	sectionName: string;
	year: number;
}

export const dashboardForDepartmentStart = (dashboardData: any) => ({
	type: DashboardForDepartmentActionTypes.DASHBOARDFORDEPARTMENT_START,
	payload: dashboardData,
});

export const dashboardForDepartmentSuccess = (dashboardData: any) => ({
	type: DashboardForDepartmentActionTypes.DASHBOARDFORDEPARTMENT_SUCCESS,
	payload: dashboardData,
});

export const dashboardForDepartmentFailure = (error: string) => ({
	type: DashboardForDepartmentActionTypes.DASHBOARDFORDEPARTMENT_FAILURE,
	payload: error,
});

export const dashboardForDepartmentResponseChanged = (response: any) => ({
	type: DashboardForDepartmentActionTypes.DASHBOARDFORDEPARTMENT_RESPONSE_CHANGED,
	payload: response,
});

export const dashboardForDepartmentResponseRestStart = () => ({
	type: DashboardForDepartmentActionTypes.DASHBOARDFORDEPARTMENT_RESPONSE_REST_START,
});

export const dashboardForDepartmentAttendanceBySectionwiseStart = (payload: AttendancePayload) => ({
	type: DashboardForDepartmentActionTypes.DASHBOARDFORDEPARTMENT_ATTENDANCE_BY_SECTIONWISE_START,
	payload,
});

export const dashboardForDepartmentAttendanceBySectionwiseSuccess = (data: any) => {
	console.log('Creating success action with data:', data);
	return {
		type: DashboardForDepartmentActionTypes.DASHBOARDFORDEPARTMENT_ATTENDANCE_BY_SECTIONWISE_SUCCESS,
		payload: data
	};
};

export const dashboardForDepartmentAttendanceBySectionwiseFailure = (error: string) => ({
	type: DashboardForDepartmentActionTypes.DASHBOARDFORDEPARTMENT_ATTENDANCE_BY_SECTIONWISE_FAILURE,
	payload: error,
});

export const dashboardForDepartmentAttendanceBySectionwiseResponseChanged = (response: any) => ({
	type: DashboardForDepartmentActionTypes.DASHBOARDFORDEPARTMENT_ATTENDANCE_BY_SECTIONWISE_RESPONSE_CHANGED,
	payload: response,
});

export const dashboardForDepartmentAttendanceBySectionwiseResponseRestStart = () => ({
	type: DashboardForDepartmentActionTypes.DASHBOARDFORDEPARTMENT_ATTENDANCE_BY_SECTIONWISE_RESPONSE_REST_START,
});
